
import { defineComponent } from 'vue'

import { validateFileNames, validateFileSize } from '~/utils/files'

export default defineComponent({
  name: 'SupportDescription',
  data() {
    return {
      isComponentLoading: true
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    isProcessingFiles: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**
     * Validates and emits new files on `change` event of file input.
     *
     * @param {Event} event - Change event of a file
     * @param {HTMLInputElement} target
     * @returns {void}
     */
    prepareFiles({ target }: { target: HTMLInputElement }): void {
      if (target.files) {
        this.$emit('update-files-processing', true)
        const arrayOfFiles = Array.from(target.files)
        try {
          if (
            !validateFileSize(
              arrayOfFiles,
              10_485_760 //? 10,485,760 = 10MB
            )
          ) {
            this.$toast.danger('Total size of attachments should be less than 10 MB.')
            return
          }

          if (!validateFileNames(arrayOfFiles)) {
            this.$toast.danger(
              'File names must be 256 characters or less and cannot contain special characters.'
            )
            return
          }
          this.$emit('files-change', arrayOfFiles)
        } catch (err) {
          this.$toast.danger('An error occurred while processing files.')
        } finally {
          this.$emit('update-files-processing', false)
        }
      }
    }
  }
})
